<template>
  <div class="w-full max-h-screen bg-background flex flex-col relative">
    <page-header title="Codes" backTo="internal">
<!--      <router-link-->
<!--          :to="{ name: 'code-create' }"-->
<!--          class="flex items-center bg-green-200 border hover:bg-green-300 border-green-400 hover:border-green-500 hover:shadow active:shadow-inner transition duration-300 text-secondary rounded-md px-2 py-1"-->
<!--      >-->
<!--        <svg-->
<!--            class="stroke-current h-5 w-5 mr-2"-->
<!--            fill="none"-->
<!--            stroke-width="2"-->
<!--            stroke-linecap="round"-->
<!--            stroke-linejoin="round"-->
<!--            viewBox="0 0 24 24"-->
<!--        >-->
<!--          <path d="M12 5v14M5 12h14"/>-->
<!--        </svg>-->
<!--        <span>New Code</span>-->
<!--      </router-link>-->
    </page-header>

    <div class="p-6 bg-background flex-1 overflow-y-scroll">
      <div class="w-full bg-white p-5 rounded shadow-md relative">
        <div class="flex justify-between items-center mb-4">
          <TabHeaders :tabs="tabs" :selectedTab="currentTab" @tab-selected="onTabSelected"/>
          <div class="flex flex-1 justify-end">
            <input
                type="text"
                class="ml-10 w-full lg:w-1/2 rounded-l bge-input bge-input-spacing"
                placeholder="Search"
                v-model="searchInput"
                @keydown.enter="triggerSearch"
            />
            <button
                @click="triggerSearch"
                class="rounded-r bg-blue-200 hover:bg-blue-300 border border-blue-400 hover:border-blue-500 p-2 hover:shadow active:shadow-inner transition-colors duration-300 ease-in-out"
            >
              <Icon iconType="search"/>
            </button>
          </div>
        </div>

        <DataTableComponent :columns="columns" @row-click="onRowClick">
          <template v-slot:timestamp-slot="{ rowData }">
            {{ formatTimestamp(rowData.created_at) }}
          </template>

          <template v-slot:status-slot="{ rowData }">
              <span
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide"
                  :class="rowData.status === 'GENERATED'
                    ? 'bg-green-100 text-green-700 border border-green-200'
                    : rowData.status === 'UNDER_QUERY'
                      ? 'bg-yellow-100 text-yellow-700 border border-yellow-200'
                      : rowData.status === 'RESOLVED'
                        ? 'bg-blue-100 text-blue-700 border border-blue-200'
                        : 'bg-gray-100 text-gray-700 border border-gray-200'"
              >
                {{ formatStatus(rowData.status) }}
              </span>
          </template>

          <template v-slot:query-status-slot="{ rowData }">
              <span
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide"
                  :class="getQueryBadgeClass(rowData)"
              >
                {{ getQueryStatusText(rowData) }}
              </span>
          </template>

          <template v-slot:chargeable-slot="{ rowData }">
              <span
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide"
                  :class="rowData.chargeable
                    ? 'bg-red-100 text-red-700 border border-red-200'
                    : 'bg-gray-100 text-gray-700 border border-gray-200'"
              >
                {{ rowData.chargeable ? 'Chargeable' : 'Non-chargeable' }}
              </span>
          </template>

          <template v-slot:custom-actions-slot="{ rowData }">
            <div class="flex justify-end items-center">
              <button
                  type="button"
                  @click.stop="editCode(rowData)"
                  class="ml-2 bg-blue-200 border hover:bg-blue-300 border-blue-400 hover:border-blue-500 hover:shadow active:shadow-inner transition duration-300 text-secondary rounded-md px-2 py-1"
              >
                <Icon iconType="edit"/>
              </button>
              <button
                  type="button"
                  @click.stop="deleteCode(rowData)"
                  class="ml-2 bg-red-200 border hover:bg-red-300 border-red-400 hover:border-red-500 hover:shadow active:shadow-inner transition duration-300 text-secondary rounded-md px-2 py-1"
              >
                <Icon iconType="delete"/>
              </button>
            </div>
          </template>
        </DataTableComponent>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import TabHeaders from "@/components/TabHeaders.vue";
import DataTableComponent from "./Components/DataTableComponent.vue";
import Icon from "@/components/Icon.vue";
import { mapActions, mapState } from "vuex";
import notificationMixin from "@/mixins/notificationMixin";
import CodeService from "@/services/codeService";

export default {
  mixins: [notificationMixin],
  components: {
    PageHeader,
    TabHeaders,
    DataTableComponent,
    Icon,
  },
  data() {
    return {
      tabs: [
        { id: "all", label: "All", iconType: "table-list" },
        { id: "query_open_not_responded", label: "Query Open", iconType: "not-confirmed" },
        { id: "chargeable_true", label: "Chargeable", iconType: "gbp" },
      ],
      columns: [
        { field: "code_id", header: "Code ID", sortable: true, custom: false, width: "12%" },
        { field: "created_at", header: "Date / Time", sortable: true, custom: true, slotName: "timestamp-slot", width: "13%" },
        { field: "distributor_name", header: "Distributor", sortable: true, custom: false, width: "15%" },
        { field: "engineer_name", header: "Engineer", sortable: true, custom: false, width: "15%" },
        { field: "type", header: "Type", sortable: true, custom: false, width: "12%" },
        { field: "status", header: "Status", sortable: true, custom: true, slotName: "status-slot", width: "10%" },
        { field: "query_status", header: "Query", sortable: false, custom: true, slotName: "query-status-slot", width: "10%" },
        { field: "chargeable", header: "Chargeable", sortable: true, custom: true, slotName: "chargeable-slot", width: "10%" },
        { field: "actions", header: "", sortable: false, custom: true, slotName: "custom-actions-slot", width: "8%" },
      ],
      CodeService,
    };
  },
  computed: {
    ...mapState("code", ["currentTab"]),
    searchInput: {
      get() {
        return this.$store.state.code.tabs.search ? this.$store.state.code.tabs.search.searchText : this.$store.state.code.tabs.all.searchText;
      },
      set(value) {
        const tab = this.currentTab === "all" ? "all" : this.currentTab;
        this.$store.commit("code/UPDATE_SEARCH_TEXT", { tab, searchText: value });
      },
    },
    currentTabState() {
      return this.$store.state.code.tabs[this.currentTab];
    },
  },
  mounted() {
    this.fetchTableData();
  },
  methods: {
    ...mapActions("code", ["fetchTableData", "updateTab"]),
    formatTimestamp(unix) {
      return this.$moment.unix(unix).format("DD-MM-YYYY HH:mm");
    },
    onTabSelected(newTab) {
      this.setTab(newTab);
    },
    setTab(newTab) {
      this.$store.dispatch("code/updateTab", newTab);
    },
    triggerSearch() {
      this.$store.commit("code/UPDATE_CURRENT_PAGE", { tab: this.currentTab, page: 1 });
      this.setTab(this.currentTab);
    },
    onRowClick(event) {
      this.editCode(event.data);
    },
    editCode(row) {
      this.$router.push({ name: "code-edit", params: { codeId: row.code_id } });
    },
    async deleteCode(row) {
      const confirmed = await this.confirmAction({ message: `Are you sure you want to delete code '${row.code_id}'?` });
      if (!confirmed) return;
      try {
        await this.CodeService.deleteCode(row.code_id);
        await this.$store.dispatch("code/fetchTableData");
        this.notifySuccess("Code deleted successfully.");
      } catch (e) {
        this.notifyError("Failed to delete code.");
      }
    },
    formatStatus(status) {
      const s = (status || "").toString().trim().toUpperCase();
      if (s === "GENERATED") return "Generated";
      if (s === "UNDER_QUERY") return "Under Query";
      if (s === "RESOLVED") return "Resolved";
      if (s === "EXPIRED") return "Expired";
      return s ? s.charAt(0) + s.slice(1).toLowerCase() : "";
    },
    getQueryStatusText(row) {
      const queries = row && row.queries ? row.queries : [];
      if (!queries.length) return "None";
      const last = queries[queries.length - 1];
      if (last && last.response) return "Responded";
      return "Open";
    },
    getQueryBadgeClass(row) {
      const queries = row && row.queries ? row.queries : [];
      if (!queries.length) return "bg-gray-100 text-gray-700 border border-gray-200";
      const last = queries[queries.length - 1];
      if (last && last.response) return "bg-green-100 text-green-700 border border-green-200";
      return "bg-yellow-100 text-yellow-700 border border-yellow-200";
    },
  },
};
</script>
